import { useEffect, type RefObject } from "react";

/** Tell the host page how tall the widget is, so it can size the iframe: window.addEventListener("message", e => e.data?.type === "criccenter-embed-height" && (iframe.style.height = e.data.height + "px")) */
export const useReportHeight = (ref: RefObject<HTMLElement | null>) =>
  useEffect(() => {
    const el = ref.current;
    if (!el || window.parent === window) return;
    const post = () => window.parent.postMessage({ type: "criccenter-embed-height", height: Math.ceil(el.getBoundingClientRect().height) }, "*");
    post();
    const ro = new ResizeObserver(post);
    ro.observe(el);
    return () => ro.disconnect();
  }, [ref]);
